import api from '../token';

export const ListProjecto = async () => {
  try {
    const response = await api.post('/getProjecto');
    return response.data;
  } catch (error) {
   
    return [];
  }
};

